<template>
  <div v-if="!hasPermission('List Cost Center')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar />
    <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                    d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                    fill="black"></path>
              </svg>
            </span>
            <input type="text" data-kt-user-table-filter="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar ...">
          </div>
        </div>
        <div class="card-toolbar">
          <button v-if="hasPermission('Store Cost Center')" class="btn btn-flex btn-primary m-1" data-bs-toggle="modal"
                  title="Novo centro de custo" data-bs-target="#modal_store_cost_center"
                  @click="resetFormStore">
            <i class="bi bi-plus-lg"></i> Adicionar
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <table class="table table-row-bordered gy-5">
          <thead>
          <tr class="fw-bold fs-6 text-muted">
            <th>Nome</th>
            <th>Descrição</th>
            <th>Ativo</th>
            <th>Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="costCenter in costCentersFiltered" :key="costCenter.id">
            <td>{{ costCenter.name }}</td>
            <td>{{ costCenter.description || '-' }}</td>
            <td>
              <span :class="costCenter.active ? 'badge badge-success' : 'badge badge-danger'">
                {{ costCenter.active ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>
              <button v-if="hasPermission('Update Cost Center')" type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      :disabled="costCenter.is_system"
                      :data-bs-toggle="costCenter.is_system ? null : 'modal'"
                      :data-bs-target="costCenter.is_system ? null : '#modal_edit_cost_center'"
                      @click="onClickBtnEdit(costCenter)"
                      :title="costCenter.is_system ? 'Registros do sistema não podem ser editados' : 'Editar'">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button v-if="hasPermission('Delete Cost Center')" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      :disabled="costCenter.is_system"
                      @click="deleteCostCenter(costCenter.id)"
                      data-bs-toggle="tooltip"
                      :title="costCenter.is_system ? 'Registros do sistema não podem ser excluídos' : 'Excluir'">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="costCentersFiltered.length === 0">
            <td colspan="4" class="text-center text-muted py-10">
              Nenhum centro de custo cadastrado
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Store -->
    <div class="modal fade" tabindex="-1" id="modal_store_cost_center">
      <div class="modal-dialog modal-lg">
        <form method="post" @submit.prevent="submitFormStore">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Novo Centro de Custo</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_store" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_store"
                           placeholder="Ex: Marketing, Vendas, Administrativo"
                           v-model="formStore.name" required>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="description_store" class="form-label">Descrição</label>
                    <textarea class="form-control form-control-solid" id="description_store"
                              rows="3" placeholder="Descrição opcional do centro de custo"
                              v-model="formStore.description"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formStore.active" id="active_store" checked/>
                    <label class="form-check-label" for="active_store">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Cadastrar</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal Edit -->
    <div class="modal fade" tabindex="-1" id="modal_edit_cost_center">
      <div class="modal-dialog modal-lg">
        <form method="post" @submit.prevent="submitFormEdit">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Editar Centro de Custo</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_edit" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_edit"
                           placeholder="Ex: Marketing, Vendas, Administrativo"
                           v-model="formEdit.name" required>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="description_edit" class="form-label">Descrição</label>
                    <textarea class="form-control form-control-solid" id="description_edit"
                              rows="3" placeholder="Descrição opcional do centro de custo"
                              v-model="formEdit.description"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formEdit.active" id="active_edit"/>
                    <label class="form-check-label" for="active_edit">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Permission from "@/helpers/permission";
import Toolbar from "@/components/layouts/auth/Toolbar.vue";

export default {
  name: "CostCenter",
  components: {
    Toolbar,
  },
  data() {
    return {
      search: '',
      costCenters: [],
      formStore: {
        name: '',
        description: '',
        active: true,
      },
      formEdit: {
        id: null,
        name: '',
        description: '',
        active: true,
      },
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    costCentersFiltered() {
      return this.costCenters.filter(costCenter => {
        return costCenter.name.toLowerCase().includes(this.search.toLowerCase()) ||
               (costCenter.description && costCenter.description.toLowerCase().includes(this.search.toLowerCase()))
      })
    },
  },
  mounted() {
    this.loadCostCenters();
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    loadCostCenters() {
      http.get(`/places/${this.place.id_place}/finances/cost-centers`).then((response) => {
        this.costCenters = response.data;
      }).catch(() => {
        this.costCenters = [];
      });
    },
    resetFormStore() {
      this.formStore = {
        name: '',
        description: '',
        active: true,
      };
    },
    submitFormStore() {
      http.post(`/places/${this.place.id_place}/finances/cost-centers`, this.formStore).then(() => {
        this.loadCostCenters();
        Alert.toastSuccess("Centro de custo cadastrado com sucesso.");
        this.resetFormStore();
        bootstrap.Modal.getInstance(document.getElementById('modal_store_cost_center')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao cadastrar centro de custo.");
      });
    },
    submitFormEdit() {
      http.put(`/places/${this.place.id_place}/finances/cost-centers/${this.formEdit.id}`, this.formEdit).then(() => {
        this.loadCostCenters();
        Alert.toastSuccess("Centro de custo atualizado com sucesso.");
        bootstrap.Modal.getInstance(document.getElementById('modal_edit_cost_center')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao atualizar centro de custo.");
      });
    },
    onClickBtnEdit(costCenter) {
      if (costCenter.is_system) {
        Alert.toastError("Registros do sistema não podem ser editados.");
        return;
      }
      this.formEdit = {
        id: costCenter.id,
        name: costCenter.name,
        description: costCenter.description || '',
        active: costCenter.active !== false,
      };
    },
    deleteCostCenter(id) {
      const costCenter = this.costCenters.find(c => c.id === id);
      if (costCenter?.is_system) {
        Alert.toastError("Registros do sistema não podem ser excluídos.");
        return;
      }
      Swal.fire({
        title: 'Tem certeza?',
        text: "Esta ação não pode ser desfeita!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/finances/cost-centers/${id}`).then(() => {
            this.loadCostCenters();
            Alert.toastSuccess("Centro de custo excluído com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response?.data?.message || "Erro ao excluir centro de custo.");
          });
        }
      });
    },
  }
}
</script>

<style scoped>
</style>


